var _templateObject, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgHana = function SvgHana(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hana_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#df9199",
    stroke: "currentColor",
    d: "M20.427.5c2.556 0 4.873 1.042 6.679 2.864l.001.001 9.664 9.695a9.25 9.25 0 0 1 2.63 5.221l-.025-.025v1.25a9.24 9.24 0 0 1-1.513 5.087l-.18.273.18.275a9.27 9.27 0 0 1 1.513 5.086c0 5.122-4.14 9.273-9.242 9.273a9.17 9.17 0 0 1-5.069-1.518l-.274-.18-.275.18a9.2 9.2 0 0 1-5.069 1.518 9.2 9.2 0 0 1-6.552-2.736l-.002-.001-9.664-9.695-.31-.323A9.25 9.25 0 0 1 .5 20.491c0-1.88.558-3.626 1.513-5.084l.18-.273-.18-.275A9.27 9.27 0 0 1 .5 9.773C.5 4.651 4.64.5 9.742.5a9.2 9.2 0 0 1 5.067 1.518l.274.18.275-.18A9.2 9.2 0 0 1 20.427.5Z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ab3a29",
    d: "M14.375 13.75a.625.625 0 1 0 1.25 0V9.688a4.688 4.688 0 1 1 4.688 4.687H17.5a.625.625 0 1 0 0 1.25h2.813a4.688 4.688 0 1 1-4.688 4.688V16.25a.625.625 0 1 0-1.25 0v4.063a4.688 4.688 0 1 1-4.687-4.688H12.5a.625.625 0 1 0 0-1.25H9.688a4.688 4.688 0 1 1 4.687-4.687z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c2b27",
    d: "M31.863 30.66a1.56 1.56 0 0 1 1.783.968l-.642.246a.875.875 0 1 0 .029.54l.664.178a1.562 1.562 0 1 1-1.834-1.933"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c2b27",
    fillRule: "evenodd",
    d: "M32.188 29.375a2.813 2.813 0 1 1 0 5.625 2.813 2.813 0 0 1 0-5.625m0 .619a2.193 2.193 0 1 0 0 4.387 2.193 2.193 0 0 0 0-4.387",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hana_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  }))))));
};
export default SvgHana;